import _ from 'lodash'
import fp from 'lodash/fp'
import cookie from '@/common/utils/cookie'
import constant from '@/common/resources/constant'
import { SEARCH_HISTORY_LOCAL_STORAGE_KEY, SERVICE_LOCATION_KEY } from '@/common/resources/const'
import { getEmergencyInfo, getUser } from '@/common/utils/request'
import { parseUrl } from 'query-string'
import { logoutProc } from '@/common/utils/login'
import { setReferer } from '@/common/utils/referer'

export const isFalsy = val => _.isNil(val) || val === ''
export const getCheckAdult = () => {
  return String(cookie.getItem('verifiedAdult')) === '1'
}
export const getGUID = () => _.get(JSON.parse(localStorage.getItem('guid')), 'guid', '')
export const setGUID = guid => {
  localStorage.setItem('guid', JSON.stringify(guid))
}
export const setIp = ip => {
  localStorage.setItem('ip', ip)
}
export const getIp = () => localStorage.getItem('ip')
export const setUserID = userID => {
  localStorage.setItem('user-id', userID)
}
export const getUserID = () => {
  return localStorage.getItem('user-id')
}
export const addPostfix = (source, postfix) => {
  const isEmpty = isFalsy(source)
  if (isEmpty) return ''
  const ext = '.' + source.split('.').pop()
  const pattern = new RegExp('\\' + ext + '$', 'g')
  return source.replace(pattern, '_' + postfix + ext)
}
export const addPostfixAndUrl = (source, postfix) => window.location.protocol + '//' + addPostfix(source, postfix)
export const getDateFromTimeString = timeString => {
  const isNotTimeString = isFalsy(timeString)
  if (isNotTimeString) {
    return new Date()
  }
  const splitString = timeString.match(/^(\d+)-(\d+)-(\d+) (\d+):(\d+)$/)
  return new Date(splitString[1], splitString[2] - 1, splitString[3], splitString[4], splitString[5])
}
export const isStaging = () => {
  return true
}
export const getDrm = () => {
  let agent = navigator.userAgent.toLowerCase()
  let findAgent = 'none'
  // IE
  if (agent.indexOf('msie') !== -1 || agent.indexOf('trident') !== -1) {
    findAgent = 'wc'
  } else if (agent.indexOf('chrome') !== -1 || agent.indexOf('firefox') !== -1) {
    findAgent = 'wm'
  } else if (agent.indexOf('safari') !== -1) {
    findAgent = 'fp'
  }
  return findAgent
}
export const getUserInfo = () => {
  const userInfo = {
    credentialKey: encodeURIComponent(cookie.getCredential()),
    GUID: getGUID(),
    clientIP: getIp(),
    userNo: cookie.getUno(),
    userID: getUserID(),
    profileID: cookie.getProfileId(),
    pooqzoneType: cookie.getPooqZoneType()
  }
  return getUser().then(({ data }) => {
    userInfo.adultverification = _.get(data, 'adultverification', '')
    return userInfo
  }).catch(() => {
    return userInfo
  })
}
export const setDisableScrolling = (isEnable) => {
  document.body.style.overflow = isEnable ? 'hidden' : ''
}
export const showRequiredLoginPopup = () => {
  if (cookie.getCredential() === 'none') {
    let confirmLogin = confirm(constant.MSG_NEED_FOR_MOVING_LOGIN)
    if (confirmLogin) {
      window.location.href = '/member/login.html?referer=' + encodeURIComponent(location.href.replace(location.origin, ''))
    }
    return true
  }
  return false
}

export const setReplaceAll = (content, word, changeWord) => {
  let specials = new RegExp('[.*+?|()\\[\\]{}\\\\]', 'g') // .*+?|()[]{}\
  let re = new RegExp(word.replace(specials, '\\$&'), 'g')
  if ((content && content.indexOf(word) >= 0) || (typeof word === 'object')) {
    content = content.replace(re, changeWord)
  }
  return content
}

export const isAdultContent = (targetAge = '0') => Number(targetAge) > 17
export const isAlreadyVerifiedAdult = () => cookie.hasCredential() && cookie.isVerifiedAdultUser()

export const goVerifyAdultPage = ({ referer = '/index.html', enter = location.pathname + location.search }) => {
  // 로그인, 성인인증 후 페이지 이동을 위해 쿠키에 진입, 현제 페이지 저장
  // if (!referer || referer.indexOf('/adult.html') >= 0) {
  //   referer = document.referrer || '/index.html'
  // }
  // cookie.removeItems({ keyList: ['referer-url', 'enter-url'] })
  // cookie.setItem('referer-url', referer || '/', false, constant.URL_COOKIE_DOMAIN, '/')
  // cookie.setItem('enter-url', enter || '/', false, constant.URL_COOKIE_DOMAIN, '/')
  // 로그인이 필요한 경우 로그인 페이지로 이동

  // console.log('REFERER ------ ', referer)
  // console.log('ENTER ------ ', enter)

  if (cookie.hasCredential()) { // 성인인증 페이지로
    location.replace('/adult?referer=' + encodeURIComponent(referer) + '&enter=' + encodeURIComponent(enter))
  } else { // 로그인 먼저 로그인 햇을때
    console.log('enter url : ', enter)
    location.replace('/member/login?referer=' + encodeURIComponent(enter))
  }
}

export const showCoinPopup = ({ isAuto = false, returnUrl }) => {
  const credential = cookie.getCredential()
  if (showRequiredLoginPopup()) return
  const popup = window.open(constant.URL_BILLING_PRODUCT_COIN +
    '?credential=' + encodeURIComponent(credential) +
    '&isAuto=' + (isAuto ? 1 : 0) +
    '&returnUrl=' + encodeURIComponent(returnUrl) +
    '&deviceTypeId=pc&marketTypeId=generic', '', 'width=700, height=780, scrollbars=yes')
  popup.focus()
}

export const showBillingPopup = ({ productId, productType, returnUrl, contentType, contentId, promotionCode = '' }) => {
  const credential = cookie.getCredential()
  if (credential === 'none') {
    if (confirm(constant.MSG_NEED_FOR_MOVING_LOGIN)) {
      window.location.href = '/member/login.html?referer=' + encodeURIComponent(location.href.replace(location.origin, ''))
    }
    return
  } else {
    // 소셜 로그인 회원일 때 다시 한번 결제 확인
    let loginType = cookie.userInfo('type')
    if (loginType === 'facebook' || loginType === 'kakao' || loginType === 'naver' || loginType === 'tid') {
      if (!confirm(constant.MSG_VOUCHER_SNS_ALERT)) {
        return
      }
    }
  }
  window.successVoucherPurchase = function () {
    logoutProc().then(() => {
      alert('이용권 변경으로 프로필 정보가 상이하여 로그아웃됩니다. 재로그인 후 이용해 주세요.')
      window.location.href = '/index.html'
    }).catch((err) => {
      console.log(err)
    })
  }
  const popup = window.open(constant.URL_BILLING_PAYMENT +
    '?credential=' + encodeURIComponent(credential) +
    '&productId=' + encodeURIComponent(productId) +
    '&productType=' + productType +
    '&returnUrl=' + encodeURIComponent(returnUrl) +
    '&contentType=' + encodeURIComponent(contentType) +
    '&contentid=' + encodeURIComponent(contentId) +
    '&promotionCode=' + encodeURIComponent(promotionCode) +
    '&deviceTypeId=pc&marketTypeId=generic&partnerUserKey=', 'PaymentWindow', 'width=700, height=780, scrollbars=yes')
  popup.focus()
}
export const setEnterChange = (content, changeWord = '<br>') => {
  return content.replace(/(?:\r\n|\r|\n)/g, changeWord)
}

export const isNumberCheck = (text) => {
  const regNumber = /^[0-9]*$/
  return regNumber.test(text)
}
export const getSecondToTime = (seconds) => {
  let playTime = ''
  let hour = Math.floor(seconds / 3600)
  let minute = Math.floor(seconds % 3600 / 60)
  let second = ''

  if (seconds < 60) {
    // 초 데이터
    if (seconds < 10) second = '00:' + '0' + seconds
    if (seconds > 10) second = '00:' + seconds

    playTime = second
  } else if (seconds < 3600) {
    // 분초 데이터
    second = seconds - (minute * 60)

    if (minute < 10) minute = '0' + minute
    if (second < 10) second = '0' + second

    playTime = minute + ':' + second
  } else {
    // 시분초 데이터
    second = seconds - (hour * 3600) - (minute * 60)

    if (minute < 10) minute = '0' + minute
    if (second < 10) second = '0' + second

    playTime = hour + ':' + minute + ':' + second
  }
  return playTime
}

export const getTimeStamp = () => {
  let date = new Date()
  let requestTime = ''
  requestTime += date.getFullYear() + '-'
  requestTime += ('00' + (date.getMonth() + 1)).slice(-2) + '-'
  requestTime += ('00' + (date.getDate())).slice(-2) + ' '
  requestTime += ('00' + (date.getHours())).slice(-2) + ':'
  requestTime += ('00' + (date.getMinutes())).slice(-2) + ':'
  requestTime += ('00' + (date.getSeconds())).slice(-2)
  return requestTime + '+900'
}

export const getUnixTimeStamp = () => {
  return Math.floor(new Date().getTime() / 1000)
}

export const setSearchWordSave = (text) => {
  localStorage.setItem(SEARCH_HISTORY_LOCAL_STORAGE_KEY,
    fp.flow(
      fp.split('&'),
      fp.compact,
      fp.thru(list => {
        list.unshift(text)
        return list
      }),
      fp.thru(list => _.uniq(list)),
      fp.slice(0, 20),
      fp.join('&')
    )(localStorage.getItem(SEARCH_HISTORY_LOCAL_STORAGE_KEY)))
}

export const clickLink = (url) => {
  if (url.startsWith('www.pooq.co.kr')) {
    window.location.href = url.replace('www.pooq.co.kr', '')
  } else if (url.startsWith('www.wavve.com')) {
    window.location.href = url.replace('www.wavve.com', '')
  } else if (url.startsWith('member.pooq.co.kr')) {
    window.location.href = 'https://' + url
  } else if (url.startsWith('member.wavve.com')) {
    window.location.href = 'https://' + url
  } else {
    const hasProtocol = url.substring(0, 4) === 'http'
    window.open((hasProtocol ? url : 'https://' + url), '_blank')
  }
}

export const hasProtocol = url => url.substring(0, 4) === 'http'

export const bannerLink = (url) => {
  if (url.indexOf('captvpooq://purchasewebview') > -1) {
    const { query } = parseUrl(url)
    showBillingPopup({ productId: query.productId, productType: 'all', returnUrl: constant.URL_PROTOCOL_WITH_DOMAIN })
  } else {
    const hasWavveDomain = url.indexOf('wavve.com') > -1
    const hasPooqDomain = url.indexOf('pooq.co.kr') > -1
    if (hasWavveDomain || hasPooqDomain) {
      let newUrl = hasProtocol(url) ? url : prependProtocol(url)
      if (url.indexOf('member.wavve.com') > -1) {
        newUrl = newUrl.replace('http://', 'https://')
      }
      location.assign(newUrl.replace('pooq.co.kr', 'wavve.com'))
    } else {
      location.assign(hasProtocol(url) ? url : prependProtocol(url))
    }
  }
}

export const setNumberCommas = (number = '') => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
export const prependProtocol = url => location.protocol + '//' + url

export const setLibFile = (d, s, id, url) => {
  let js
  let fjs = d.getElementsByTagName(s)[0]
  if (d.getElementById(id)) {
    return
  }
  js = d.createElement(s)
  js.id = id
  js.src = url
  fjs.parentNode.insertBefore(js, fjs)
}

export const getResultCodeInResponse = response => _.get(response, ['data', 'resultcode'], '')
export const getResultMessageInResponse = response => _.get(response, ['data', 'resultmessage'], '')
export const needSelectProfile = response => _.get(response, 'needselectprofile', 'n') === 'y'
export const getStatusInResponse = response => _.get(response, 'status', '')

export const isProductMode = process.env.NODE_ENV === 'production'

export const isPrerenderer = () => {
  return _.get(window, ['__PRERENDER_INJECTED', 'isPreRender'], '') === 'y'
}

export const currentProtocolEqualTo = (protocol) => location.protocol === protocol

export const getThumbnailInfo = (cellType) => {
  const MultiPlyRatio = 1.5
  let number = _.get(cellType.match(/\d+/g), '0', 99)
  const res = {
    type: cellType,
    typeNumber: '',
    width: '',
    height: ''
  }
  if (number < 8) {
    res.width = Math.round(240 * MultiPlyRatio)
    res.height = Math.round(135 * MultiPlyRatio)
    res.containerSize = 327
    res.componentName = 'landscape-cell'
    res.placeholderImage = require('../../assets/images/common/img_default_thum_2.png')
    res.isSquare = false
  } else if (number < 15) {
    res.width = Math.round(240 * MultiPlyRatio)
    res.height = Math.round(346 * MultiPlyRatio)
    res.containerSize = 510
    res.componentName = 'portrait-cell'
    res.placeholderImage = require('../../assets/images/common/img_default_thum_1.png')
    res.isSquare = false
  } else if (number < 22) {
    res.width = Math.round(160 * MultiPlyRatio)
    res.height = Math.round(160 * MultiPlyRatio)
    res.containerSize = 242
    res.componentName = 'circle-cell'
    res.placeholderImage = require('../../assets/images/common/img_default_thum_3.png')
    res.isSquare = true
  } else {
    res.width = 0
    res.height = 0
    res.componentName = cellType
    res.placeholderImage = ''
    res.isSquare = false
  }
  return res
}
export const commonErrorProcess = (error) => {
  if (error.response && error.response.status === 550) {
    let message = error.response.data.resultmessage ? error.response.data.resultmessage
      : '서버에서 알 수 없는 오류가 발생했습니다.'
    alert(message.replace('\\\\n', '\n').replace('\\n', '\n'))
  }
}
export const scrollTop = () => {
  window.scrollTo(0, 0)
}
export const scrollTopWithCallback = (callback) => {
  scrollTop()
  callback && callback()
}

export const scrollToElement = (selector) => {
  const el = document.querySelector(selector)
  if (el !== null) {
    let bodyRect = document.body.getBoundingClientRect()
    let elemRect = el.getBoundingClientRect()
    let offset = (elemRect.top - bodyRect.top)
    window.scrollTo(0, offset)
  }
}

const getReferer = () => {
  return cookie.getItem('referer-url') || document.referrer || '/index.html'
}

export const redirectToHttps = () => {
  if (isPrerenderer()) return
  if (window.location.protocol === 'http:') {
    console.log('redirectToHttps - http')
    let referer = getReferer()
    if (referer.indexOf('/adult.html') > -1) {
      referer = '/index.html'
    }
    setReferer(referer)
    const url = location.href.replace(location.protocol, 'https:')
    if (isProductMode) {
      location.replace(url)
      return false
    }
  }
}

export const allowDeviceCheck = () => {
  if (isPrerenderer()) return
  const deviceType = window.uaInfo.getDevice().type
  if (isProductMode) {
    if (deviceType === 'mobile' || deviceType === 'tablet') {
      location.replace(location.href.replace(location.hostname, 'm.wavve.com'))
    }
  }
}

export const pad = (num, width) => {
  let numStr = num + ''
  return numStr.length >= width ? numStr
    : new Array((width - numStr.length) + 1).join('0') + numStr
}

export const logger = color => (text) => {
  const str = typeof (text) === 'object' ? JSON.stringify(text) : text
  console.log(`%c ${str}`, `background: #222; color:${color};font-size: 15px`)
}

export const changeReferer = (referer) => {
  return referer.replace(location.protocol + '//' + location.host, '')
}

export const replaceSpecialCharacters = (string) => {
  // eslint-disable-next-line
  const regExp = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi
  return _.replace(string, regExp, '') // ?
}

export const replaceSpecialCharactersFilter = (string) => {
  // eslint-disable-next-line
  const regExp = /[\{\}\/?.,;:|\)*~`!^\_+@\#%&\\\\(\']/gi
  // const regExp = /[\{\}\[\]\/?.,;:|\)*~`!^\_+@\#%&\\\\(\']/gi
  return _.replace(string, regExp, '') // ?
}

export const isExplorer = () => {
  let agent = navigator.userAgent.toLowerCase()
  return agent.indexOf('msie') !== -1 || agent.indexOf('trident') !== -1
}

export const destroyPlayer = () => {
  window.playerInstance && window.playerInstance.unload && window.playerInstance.unload()
}

export const detachPlayerEvents = () => {
  window.playerInstance && window.playerInstance.removeEvents && window.playerInstance.removeEvents()
}

export const isIos13IPad = () => {
  const userAgent = navigator.userAgent.match(/Mac|MacIntel/) === null ? [] : navigator.userAgent.match(/Mac|MacIntel/)
  return userAgent.length > 0 && navigator.maxTouchPoints > 2
}

// const isPooqDomain = location.hostname === 'www.pooq.co.kr'
// const isShortPooqDomain = location.hostname === 'pooq.co.kr'
// const isWavveDomain = location.hostname === 'www.wavve.com'
const isProduction = process.env.NODE_ENV === 'production'
const deviceType = window.uaInfo.getDevice().type
const isMobileDevice = deviceType === 'mobile' || deviceType === 'tablet' || isIos13IPad()
const toDomain = isMobileDevice ? 'm.wavve.com' : 'www.wavve.com'

export const asyncRedirectWithParam = () => {
  if (isPrerenderer()) return Promise.resolve()
  if (!isProduction) return Promise.resolve()
  return new Promise((resolve, reject) => {
    let toUrl = location.href
    if (location.hostname === 'www.pooq.co.kr') {
      reject(toUrl.replace('www.pooq.co.kr', toDomain).replace(location.protocol, 'https:'))
    } else if (location.hostname === 'pooq.co.kr') {
      reject(toUrl.replace('pooq.co.kr', toDomain).replace(location.protocol, 'https:'))
    } else if (location.hostname === 'wavve.com') {
      reject(toUrl.replace('www.wavve.com', toDomain).replace(location.protocol, 'https:'))
    } else if (location.hostname === 'www.wavve.com') {
      if (location.protocol === 'http:' || isMobileDevice) {
        reject(toUrl.replace(location.hostname, toDomain).replace(location.protocol, 'https:'))
      } else {
        resolve(true)
      }
    }
  })
  // if (isPrerenderer()) return
  // if (!isProduction) return
}

// export const isRootPath = location.pathname === '/' || location.pathname === '/index' || location.pathname === '/index.html'
// export const autoLoginTransfer = () => {
//   if (isPrerenderer()) return
//   const protocol = isProduction ? 'https://' : 'http://'
//   const savedUserId = cookie.getSaveUserId()
//   const savedCredential = cookie.getAutoLoginCredential() || 'none'
//   const isAutoLoginPath = location.pathname === '/autologin'
//   if (isPooqDomain && isRootPath) {
//     if (savedUserId !== 'none' || savedCredential !== 'none') {
//       let url = `${protocol}www.wavve.com/autologin?`
//       const queryParam = {}
//       if (savedUserId !== 'none') {
//         queryParam.userid = savedUserId
//         cookie.removeItem('userId', constant.URL_COOKIE_DOMAIN, '/')
//       }
//       if (savedCredential !== 'none') {
//         queryParam.key = `${decodeURIComponent(savedCredential).replace(/"/gi, '')}`
//         cookie.removeItem('cs', constant.URL_COOKIE_DOMAIN, '/')
//         cookie.removeItem('credential', constant.URL_COOKIE_DOMAIN, '/')
//       }
//       location.href = `${url}${stringify(queryParam)}`
//     } else {
//       location.href = 'https://www.wavve.com/index.html'
//     }
//   } else if (isWavveDomain && isAutoLoginPath) {
//     const { query } = parseUrl(location.href)
//     const userId = _.get(query, 'userid', '')
//     const credential = _.get(query, 'key', '')
//     try {
//       if (userId !== '') {
//         saveIdProcess({ saveId: true, userId })
//       }
//       if (credential !== '') {
//         setAutoLoginInfo({ autoLogin: true, credential })
//       }
//       location.href = `${protocol}www.wavve.com/index.html`
//     } catch (e) {
//       location.replace(`${protocol}www.wavve.com/index.html`)
//     }
//   } else {
//     console.log('redirectiWithParams')
//     redirectWithParam()
//   }
// }

export const removePrefixEmptyString = (string) => {
  const res = []
  const charList = string.split('')
  let removeComplete = false
  for (let i = 0, len = charList.length; i < len; i++) {
    if (charList[i] !== ' ') {
      removeComplete = true
    }
    if (removeComplete) {
      res.push(charList[i])
    }
  }
  return res.join('')
}

export const checkEmergency = () => {
  const emergencyPathList = [
    '/event/index',
    '/event/index.html'
  ]
  getEmergencyInfo().then(({ isEmergency, emergencyUrl }) => {
    const isEmergencyPath = emergencyPathList.filter(path => path === location.pathname).length > 0
    if (isEmergency && !isEmergencyPath) {
      location.replace(emergencyUrl)
    }
  })
}

export const emergencyPlayerProc = ({ isEmergency, emergencyUrl }) => {
  if (!isEmergency) {
    alert('무료 시청이 종료되었습니다. \n' + '다른 콘텐츠를 이용해 주세요.')
    location.replace('/')
  }
  const { name } = window.uaInfo.getBrowser()
  if (name === 'IE') {
    alert('지원되지 않는 브라우저를 사용하고 계시네요.\nIE edge, Chrome, Safari 및 Firefox로 이용해 주세요.')
  } else {
    const { query } = parseUrl(emergencyUrl)
    const title = _.get(query, 'title', '이벤트')
    const channelId = _.get(query, 'channelid', 'C9232')
    const startTime = _.get(query, 'starttime', '16:30')
    window.open(
      location.protocol + '//' + `www.wavve.com/pooqplayer/popupPlayer.html?type=live&contentID=${channelId}&resolution=1080p&isAutoPlay=false&isDVR=false&query="playtype=z"&title=${title}&starttime=${startTime}`,
      'emergencyPopup',
      'status=no, titlebar=no, toolbar=no, width=880, height=495'
    )
  }
}

export function comparePath (orgPath, checkPath) {
  let isCorrect = false
  const orgPathList = orgPath.split('/')
  const checkPathList = checkPath.split('/')
  if (orgPathList.length === checkPathList.length) {
    let matchPath = true
    orgPathList.forEach(function (path, index) {
      if (path !== '{path}') {
        matchPath = path === checkPathList[index]
      }
    })
    isCorrect = matchPath
  }
  return isCorrect
}

export function setServiceLocationInfo (serviceLocation) {
  sessionStorage.removeItem(SERVICE_LOCATION_KEY)
  sessionStorage.setItem(SERVICE_LOCATION_KEY, JSON.stringify(serviceLocation))
}

export function getServiceLocationInfo () {
  return JSON.parse(sessionStorage.getItem(SERVICE_LOCATION_KEY))
}

export function changeEscapeCharacter (text) {
  return text.replace(/&lt;/gi, '<').replace(/&gt;/gi, '>')
}

export function contentDetailErrorCatcher (err) {
  alert(_.get(err, ['response', 'data', 'resultmessage'], '해당 데이터가 없습니다.'))
  this.$router.back()
}

export function getContentDetailData (response) {
  const data = _.get(response, 'data', null)
  if (data === null) {
    alert('해당 데이터가 없습니다.')
    this.$router.back()
  }
  return data
}
